<!--<template>-->

<!--  <div class="row">-->

<!--    <div class="col-md-6 col-lg-6 col-6 mb-2">-->
<!--      <BFormFloatingLabel class="mb-2"> Book</BFormFloatingLabel>-->
<!--      <a-select-->
<!--          v-model:value="model.book"-->
<!--          class="w-100"-->
<!--          placeholder="Select a Book"-->
<!--          show-search-->
<!--          :options="Books.map(book => ({ label: book.name, value: book.name }))"-->
<!--          :filter-option="filterOption"-->
<!--          @change="onBookChange"-->
<!--      />-->
<!--    </div>-->

<!--    <div class="col-md-6 col-lg-6 col-6 mb-2">-->
<!--      <BFormFloatingLabel class="mb-2"> Chapter</BFormFloatingLabel>-->
<!--      <a-select-->
<!--          v-model:value="model.chapter"-->
<!--          class="w-100"-->
<!--          placeholder="Select a Chapter"-->
<!--          show-search-->
<!--          :options="chapterCountArray[model.book]?.map(c => ({ label: c, value: c }))"-->
<!--          :filter-option="filterOption"-->
<!--          @change="onChapterChange"-->
<!--          :disabled="!model.book"-->
<!--      />-->
<!--    </div>-->

<!--    <div class="col-md-6 col-lg-6 col-6 mb-2">-->
<!--      <BFormFloatingLabel class="mb-2"> From Verse</BFormFloatingLabel>-->
<!--      <a-select-->
<!--          v-model:value="model.from_verse"-->
<!--          class="w-100"-->
<!--          placeholder="From Verse"-->
<!--          show-search-->
<!--          :options="verseCountArray[`${model.book}-${model.chapter}`]?.map(v => ({ label: v, value: v }))"-->
<!--          :filter-option="filterOption"-->
<!--          :disabled="!model.chapter"-->
<!--      />-->
<!--    </div>-->

<!--    <div class="col-md-6 col-lg-6 col-6 mb-2">-->
<!--      <BFormFloatingLabel class="mb-2"> To Verse</BFormFloatingLabel>-->
<!--      <a-select-->
<!--          v-model:value="model.to_verse"-->
<!--          class="w-100"-->
<!--          placeholder="To"-->
<!--          show-search-->
<!--          :options="verseCountArray[`${model.book}-${model.chapter}`]?.map(v => ({ label: v, value: v }))"-->
<!--          :filter-option="filterOption"-->
<!--          :disabled="!model.chapter"-->
<!--      />-->
<!--    </div>-->

<!--  </div>-->


<!--</template>-->

<!--<script setup>-->
<!--import { computed } from 'vue'-->

<!--const props = defineProps({-->
<!--  modelValue: {-->
<!--    type: Object,-->
<!--    required: true-->
<!--  },-->
<!--  Books: {-->
<!--    type: Array,-->
<!--    required: true-->
<!--  },-->
<!--  chapterCountArray: {-->
<!--    type: Object,-->
<!--    required: true-->
<!--  },-->
<!--  verseCountArray: {-->
<!--    type: Object,-->
<!--    required: true-->
<!--  },-->
<!--  filterOption: {-->
<!--    type: Function,-->
<!--    required: true-->
<!--  }-->
<!--})-->

<!--const emit = defineEmits(['update:modelValue', 'bookChange', 'chapterChange'])-->

<!--const model = computed({-->
<!--  get: () => props.modelValue,-->
<!--  set: val => emit('update:modelValue', val)-->
<!--})-->

<!--function onBookChange() {-->
<!--  emit('bookChange', model.value)-->
<!--}-->

<!--function onChapterChange() {-->
<!--  emit('chapterChange', model.value)-->
<!--}-->
<!--</script>-->


<template>
  <div class="row">

    <div class="col-md-6 col-lg-6 col-6 mb-2">
      <BFormFloatingLabel class="mb-2">Book</BFormFloatingLabel>
      <a-select
          v-model:value="model.book"
          class="w-100"
          placeholder="Select a Book"
          show-search
          :options="Books.map(book => ({ label: book.name, value: book.name }))"
          :filter-option="filterOption"
          @change="onBookChange"
      />
    </div>

    <div class="col-md-6 col-lg-6 col-6 mb-2">
      <BFormFloatingLabel class="mb-2">Chapter</BFormFloatingLabel>
      <a-select
          v-model:value="model.chapter"
          class="w-100"
          placeholder="Select a Chapter"
          show-search
          :options="chapterCountArray[model.book]?.map(c => ({ label: c, value: c }))"
          :filter-option="filterOption"
          @change="onChapterChange"
          :disabled="!model.book"
      />
    </div>

    <div class="col-md-6 col-lg-6 col-6 mb-2">
      <BFormFloatingLabel class="mb-2">From Verse</BFormFloatingLabel>
      <a-select
          v-model:value="model.from_verse"
          class="w-100"
          placeholder="From Verse"
          show-search
          :options="verseCountArray[`${model.book}-${model.chapter}`]?.map(v => ({ label: v, value: v }))"
          :filter-option="filterOption"
          :disabled="!model.chapter"
      />
    </div>

    <div class="col-md-6 col-lg-6 col-6 mb-2">
      <BFormFloatingLabel class="mb-2">To Verse</BFormFloatingLabel>
      <a-select
          v-model:value="model.to_verse"
          class="w-100"
          placeholder="To"
          show-search
          :options="verseCountArray[`${model.book}-${model.chapter}`]?.map(v => ({ label: v, value: v }))"
          :filter-option="filterOption"
          :disabled="!model.chapter"
      />
    </div>

  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import axios from 'axios';
import { baseUrl } from '@/constants';

const props = defineProps({
  modelValue: { type: Object, required: true },
  filterOption: { type: Function, required: true },
});

const emit = defineEmits(['update:modelValue', 'bookChange', 'chapterChange']);

const model = computed({
  get: () => props.modelValue,
  set: val => emit('update:modelValue', val)
});

// State for scripture reference data
const Books = ref([]);
const chapterCountMap = ref({});
const verseCountMap = ref({});

const chapterCountArray = computed(() => chapterCountMap.value);
const verseCountArray = computed(() => verseCountMap.value);

// Fetch all books
const fetchBooks = async () => {
  const res = await axios.get(`${baseUrl}books`);
  Books.value = Array.isArray(res.data.data) ? res.data.data : [];
};

// Fetch chapters for selected book
const fetchChapters = async () => {
  if (!model.value.book) return;
  model.value.chapter = null;
  model.value.from_verse = null;
  model.value.to_verse = null;

  const res = await axios.get(`${baseUrl}books/${model.value.book}/chapters`);
  chapterCountMap.value[model.value.book] = [...Array(res.data.data.count).keys()].map(i => i + 1);
};

// Fetch verses for selected chapter
const fetchVerses = async () => {
  if (!model.value.book || !model.value.chapter) return;
  model.value.from_verse = null;
  model.value.to_verse = null;

  const res = await axios.get(`${baseUrl}books/${model.value.book}/chapters/${model.value.chapter}/verses`);
  verseCountMap.value[`${model.value.book}-${model.value.chapter}`] = [...Array(res.data.data.count).keys()].map(i => i + 1);
};

// Event handlers
function onBookChange() {
  fetchChapters();
  emit('bookChange', model.value);
}

function onChapterChange() {
  fetchVerses();
  emit('chapterChange', model.value);
}

// Load books on mount
onMounted(fetchBooks);
</script>




<style scoped>

</style>